import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

export const fetchLogo = createAsyncThunk('logoSlice/fetchLogo', async () => {
    const res = await fetch(`${process.env.REACT_APP_PROJECTS_API}components/s_d.php?logo`)
    const data = await res.json()
    return data;
})

const logoSlice = createSlice({
    initialState: {
        logo: [],
        loading: false,
        error: null,
    },
    name: 'logoSlice',
    extraReducers: (builder) => {
        builder
            .addCase(fetchLogo.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchLogo.fulfilled, (state, action) => {
                state.loading = false;
                state.logo = action.payload;
            })
            .addCase(fetchLogo.rejected, (state, action) => {
                state.loading = false;
                state.error = <p className='error-api'>The server is temporarily down Please try later!</p>;
            });
    },
})

export const { } = logoSlice.actions;

export default logoSlice.reducer;